var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-carousel"},_vm._l((_vm.items),function(item,key){return _c('div',{key:key,staticClass:"carousel-item"},[_c('product-item',{key:key,attrs:{"item":item,"theme":_vm.theme},on:{"item-click":_vm.itemClick}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }